export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4738.796563d8.jpg";